<template>
    <div class="fc" :class="{ on: isActive }" v-ripple @click="$emit('click')">
        <template v-if="createMode">
            <div class="fiw">
                <v-icon size="22" color="accent">mdi-plus</v-icon>
            </div>
            <div class="fn">{{ $t('common.create') }}</div>
        </template>
        <template v-else>
            <div class="fiw">
                <v-icon size="22" :color="isActive ? 'secondary' : 'accent'">{{ category.icon }}</v-icon>
            </div>
            <div class="fn" :class="{ 'fn--on': isActive }">{{ categoryLabel(category.name) }}</div>
        </template>
    </div>
</template>

<script>
export default {
    name: "CategoryCard",
    props: {
        createMode: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        category: {
            type: Object,
            default: null,
        },
    },
}
</script>

<style scoped>
.fc {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    padding: 18px 14px;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all .15s;
    height: 100%;
    justify-content: center;
}

.fc:hover {
    border-color: var(--v-outline2-base);
    background: var(--v-surface2-base);
}

.fc.on {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, .08);
}

.fiw {
    width: 46px;
    height: 46px;
    border-radius: 10px;
    background: var(--v-surface2-base);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.fn {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    margin-top: 10px;
}

.fn--on {
    color: var(--v-secondary-base);
}
</style>
